import { render, staticRenderFns } from "./list-promesa.vue?vue&type=template&id=f6e0b02a"
import script from "./list-promesa.vue?vue&type=script&lang=js"
export * from "./list-promesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports